export default __webpack_public_path__ + "static/media/ellipsis-horizontal.c997cc21.svg";